import React, { HTMLAttributes } from "react";

import classnames from "classnames";

import { StyledListSeparator } from "./Styles";

export const ListSeparator = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <StyledListSeparator
      className={classnames("c-list-separator", className)}
      {...props}
    />
  );
};

ListSeparator.displayName = "ListSeparator";
